import React from 'react';
import { View, Text, StyleSheet, SafeAreaView, TouchableOpacity, ScrollView } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Colors, SIZES } from '../constants/theme';
import { useRouter } from 'expo-router';
import { useAppStore } from '../store/useAppStore';
import { CUOTA_TARJETA_ENABLED } from '../constants/featureFlags';

/**
 * MÉTODOS DE PAGO — pantalla informativa (19-sep-2026).
 *
 * Antes tenía un botón "Agregar nueva tarjeta (Stripe)" que le pedía un
 * SetupIntent a Railway (borrado): no hacía nada, prometía pagar "viajes y
 * pedidos" con tarjeta (la app no lo hace: CUSTOMER_CARD_ENABLED en false) y
 * decía que se cobraba en USD. Su entrada en Perfil está oculta, pero la ruta
 * existe y se puede abrir con un enlace, así que ahora dice la verdad:
 *   · Go Safely no guarda tarjetas.
 *   · Viajes y pedidos se pagan en efectivo o por transferencia.
 *   · El chofer paga su cuota con tarjeta desde Billetera, como pago único en
 *     la página de Stripe (functions/src/pagoCuotaStripe.ts).
 */
export default function PaymentMethodsScreen() {
  const router = useRouter();
  const userRole = useAppStore((s) => s.userRole);
  const esChofer = userRole === 'DRIVER' || userRole === 'DELIVERY_DRIVER' || userRole === 'SCHOOL_DRIVER';

  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => router.canGoBack() ? router.back() : router.replace('/')} style={styles.backButton}>
          <Ionicons name="arrow-back" size={24} color={Colors.text} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Métodos de Pago</Text>
        <View style={{ width: 40 }} />
      </View>

      <ScrollView contentContainerStyle={styles.container}>
        <View style={styles.emptyState}>
          <Ionicons name="card-outline" size={36} color="#9CA3AF" style={{ marginBottom: 8 }} />
          <Text style={styles.emptyTitle}>Go Safely no guarda tarjetas</Text>
          <Text style={styles.emptySubtitle}>
            Tus viajes y pedidos se pagan en efectivo o por transferencia, directo a quien te presta el servicio.
          </Text>
        </View>

        {esChofer && CUOTA_TARJETA_ENABLED && (
          <>
            <TouchableOpacity style={styles.addCardBtn} onPress={() => router.push('/wallet')}>
              <Ionicons name="wallet-outline" size={24} color={Colors.primary} />
              <Text style={styles.addCardText}>Pagar mi cuota en Billetera</Text>
            </TouchableOpacity>
            <Text style={styles.disclaimerText}>
              Tu cuota de servicio se puede pagar con tarjeta desde Billetera: es un pago único en pesos (DOP) en la página segura de Stripe, sin cobros automáticos.
            </Text>
          </>
        )}
      </ScrollView>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: { flex: 1, backgroundColor: '#F5F7FA' },
  header: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
    paddingHorizontal: 20, paddingVertical: 15, borderBottomWidth: 1, borderBottomColor: '#F0F0F0',
    backgroundColor: '#FFF'
  },
  backButton: { padding: 8, marginLeft: -8 },
  headerTitle: { fontSize: 18, fontWeight: 'bold', color: Colors.text },
  container: { padding: 20 },
  sectionTitle: { fontSize: 14, fontWeight: 'bold', color: '#666', marginBottom: 12 },
  cardItem: {
    backgroundColor: '#FFF', borderRadius: 16, padding: 16,
    flexDirection: 'row', alignItems: 'center', marginBottom: 16,
    shadowColor: '#000', shadowOffset: { width: 0, height: 2 }, shadowOpacity: 0.05, shadowRadius: 10, elevation: 2,
  },
  cardIcon: {
    width: 48, height: 48, borderRadius: 8, backgroundColor: '#0A2540',
    justifyContent: 'center', alignItems: 'center', marginRight: 16,
  },
  cardInfo: { flex: 1 },
  cardTitle: { fontSize: 16, fontWeight: 'bold', color: '#1A1A1A', marginBottom: 4 },
  cardSubtitle: { fontSize: 13, color: '#666' },
  emptyState: {
    backgroundColor: '#FFF', borderRadius: 16, padding: 24,
    alignItems: 'center', marginBottom: 16,
    borderWidth: 1, borderColor: '#E5E7EB', borderStyle: 'dashed',
  },
  emptyTitle: { fontSize: 15, fontWeight: '700', color: '#1A1A1A', marginBottom: 4, textAlign: 'center' },
  emptySubtitle: { fontSize: 13, color: '#6B7280', textAlign: 'center', lineHeight: 18 },
  addCardBtn: {
    flexDirection: 'row', alignItems: 'center', padding: 16,
    backgroundColor: 'rgba(0, 200, 83, 0.1)', borderRadius: 16,
  },
  addCardText: { marginLeft: 10, fontSize: 16, fontWeight: 'bold', color: Colors.primary },
  disclaimerText: {
    fontSize: 12, color: '#666', textAlign: 'center', marginTop: 16, fontStyle: 'italic'
  }
});

